export function findFirstOption(options: Array<Option | Optgroup>): Option {
    // tslint:disable-next-line:forin
    for (let i in options) {
        let option = options[i];
        if (isOption(option) && option.disabled !== true) {
            return option;
        }
        if (isOptgroup(option)) {
            return findFirstOption(option.options);
        }
    }
    return {
        value: null,
        text: "",
        disabled: false,
    };
}

/**
 * A search parameter that will be hardcoded in a code searcher window.
 */
export interface SearcherParameter {
    /**
     * The property of the filter input to hardcode.
     */
    property: string;
    value: any;
}

export interface Option {
    value: string | number;
    text: string;
    disabled: boolean;
}

export interface Optgroup {
    text: string;
    translate: boolean;
    disabled: boolean;
    options: Option[];
}

export interface TableOptions extends OptionHolder {
    filter: Dictionary<Array<Option | Optgroup>>;
    columns: Dictionary<Array<Option | Optgroup>>;
    actions: Dictionary<Dictionary<Array<Option | Optgroup>>>;
}

export interface FieldOptions extends Array<Option | Optgroup | SearcherParameter>, OptionHolder { }

export interface OptionHolder { }

export interface Dictionary<T> {
    [key: string]: T;
}

export function isOption(arg: any): arg is Option {
    return arg.options === undefined;
}
export function isOptgroup(arg: any): arg is Optgroup {
    return arg.options !== undefined;
}
